module.exports = __webpack_public_path__ + "static/media/davis.a0fab042.jpg";